import { getAllOrganisationUnitsService } from '../services/organisationService';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getAllOrganisationUnits = createAsyncThunk(
  'organisationUnits/getAllOrganisationUnits',
  async () => {
    const response = await getAllOrganisationUnitsService();
    return response.data;
  }
);

// slice
const organisationUnitsSlice = createSlice({
  name: 'organisationUnits',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(getAllOrganisationUnits.pending, (state) => {
      console.log('Fetching all organisation units...');
    })
    .addCase(getAllOrganisationUnits.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    })
    .addCase(getAllOrganisationUnits.rejected, (state, action) => {
      console.error('Failed to fetch organisation units:', action.error);
    });
  },
});

export default organisationUnitsSlice.reducer;
export const { actions: organisationUnitsActions } = organisationUnitsSlice;

// Selectors
export const selectParentMap = (state) => {
  const { organisationUnits } = state;
  return Object.keys(organisationUnits).reduce((acc, id) => {
    return {
      ...acc,
      [id]: getOrganisationUnitParents(id, organisationUnits),
    };
  }, {});
};

const getOrganisationUnitParents = (unitId, organisationUnits) => {
  let allParents = [];
  const directParent = Object.values(organisationUnits).find((unit) =>
    unit.descendants.includes(unitId)
  );
  if (directParent) {
    allParents = [...allParents, directParent];
    const parentDirectParent = Object.values(organisationUnits).find((unit) =>
      unit.descendants.includes(directParent.id)
    );
    if (parentDirectParent) {
      allParents = [
        ...getOrganisationUnitParents(directParent.id, organisationUnits),
        ...allParents,
      ];
    }
  }
  return allParents;
};
